exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table {\n  margin-top: 0;\n  margin-bottom: 24px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/daily-recon.component.scss
// module id = ../../../../../src/app/views/daily-recon/daily-recon.component.scss
// module chunks = main